import React from 'react';
import ReCaptcha from "react-google-recaptcha";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Slide,
    Typography
} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {useTranslation} from "react-i18next";
import PropTypes from "prop-types";
import {GOOGLE_RECAPTCHA_SITE_KEY} from "../../../constants";

const useStyles = makeStyles((theme) => ({
    error: {
        color: theme.palette.error.main,
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props}></Slide>;
});

export default function CaptchaDialogSlide(props) {
    const classes = useStyles();
    const {t} = useTranslation('common');
    const {title, description, open, handleClose, validateCaptcha} = props;
    const [captchaValue, setCaptchaValue] = React.useState("");
    const [error, setError] = React.useState(false);

    const handleValidate = () => {
        if (captchaValue) {
            validateCaptcha(captchaValue);
        } else {
            setError(true);
        }
    };

    const handleClickClose = () => {
        handleClose(captchaValue);
    };

    const handleChange = (value) => {
        if (value)
            setCaptchaValue(value);
    };
    return (
        <div>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                onClose={handleClickClose}
                aria-labelledby="captcha-dialog-slide-title"
                aria-describedby="captcha-dialog-slide-description"
            >
                <DialogTitle id="captcha-dialog-slide-title">{title}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="captcha-dialog-slide-description">
                        {description}
                    </DialogContentText>
                    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
                        <ReCaptcha
                            onChange={handleChange}
                            sitekey={GOOGLE_RECAPTCHA_SITE_KEY}
                            placeholder="Enter captcha"
                        />
                        {error && <Typography className={classes.error}>
                            {t("main.components.captchaDialog.error")}
                        </Typography>}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleValidate} color="secondary" disabled={captchaValue === ""}>
                        {t("main.components.captchaDialog.validate")}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

CaptchaDialogSlide.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    validateCaptcha: PropTypes.func.isRequired,
}